export default __webpack_public_path__ + "62f0579e06e4d6af148e0e12eebff2a9.png";